import React from "react";

export default function CommonPopup({
    isOpen,
    message = "Are you sure?",
    onClose,
    onConfirm,
    loading = false,
    confirmText = "Yes",
    cancelText = "No",
}) {
    if (!isOpen) return null;

    return (
        <div onClick={onClose} className="img-popup-design">
            <div className="img-popup" onClick={(e) => e.stopPropagation()}>
                <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 black">
                    {message}
                </p>

                <div
                    style={{ paddingTop: 20 }}
                    className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                    <button onClick={onClose} className="no-btn f3 w-40">
                        {cancelText}
                    </button>

                    <button onClick={onConfirm} className="yes-btn f3 w-40">
                        {loading ? (
                            <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                                style={{ color: "white" }}
                            ></span>
                        ) : (
                            confirmText
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}